var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "gray",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h.01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6h.01"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 20,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon-company.08d5aac08681c6d54503350022905511.svg";
export { ForwardRef as ReactComponent };